/**
 * Every viewport threshold in the app, in one place.
 *
 * Values are full media-query strings so the same constant works as a JSS key
 * and as a useMediaQuery argument — MUI v4 strips a leading "@media" from the
 * query it receives, so the two sides cannot drift.
 *
 * Deliberately not theme.breakpoints: that API is width-only (no min-height,
 * no compound queries), its named keys don't match any threshold this app
 * actually uses, and down(key) resolves to the *next key up* minus 0.05 —
 * v4 and v5 disagree on the semantics.
 *
 * Name by what the threshold does, not by its size tier, and say why the
 * number is what it is. The number is the part nobody can reconstruct later.
 */

// MUI's convention: 0.05px below the boundary, so adjacent ranges never both match.
const below = px => `@media (max-width: ${px - 0.05}px)`;

/**
 * Top bar switches to the compact layout.
 * 1280 keeps a maximised 1366x768 laptop — a common configuration — on the
 * full layout.
 */
export const TOPBAR_COMPACT = below(1280);

/**
 * Management modal content beside the 240px rail gets tight below this viewport.
 * Projects search shortens, and the datasets controls keep a visible gap.
 */
export const MANAGEMENT_NARROW = below(880);

/** Namespace attached to the theme so stylesheets need no import. */
export default {
  topbarCompact: TOPBAR_COMPACT,
  managementNarrow: MANAGEMENT_NARROW
};
